import { status } from '../../helpers'

const getsubTeamsStoreDefaultState = () => {
  return {
    teamsList: [],
    loadTeamsList: status.INITIALIZED,
    addingNewTeam: false,
    removingTeam: false
  }
}

export default getsubTeamsStoreDefaultState
